module.exports = __webpack_public_path__ + "static/media/ex15.5157c536.mp3";